import { put, select, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from './Table.duck';
import { getIntegrations } from '../Services/IntegrationService';

export const actionTypes = {
  RequestData: '[Integrations] RequestIntegrations',
  FulfilledTable: '[Integrations] FulfilledIntegrations',
  SearchTable: '[Integrations] Search',
  ChangePage: '[Integrations] change page',
  SetPageSize: '[Integrations] set page size',
  SortTable: '[Integrations] Sort',
  ApplyFilter: '[Integrations] Apply filter',
  RemoveFilter: '[Integrations] Remove filter',
  ResetFilters: '[Integrations] Reset filter',
};

const initialState = {
  ...tableInitialState,
  page: 1,
  pageSize: 1000,
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestIntegrationsSaga() {
    const currentTenantId = yield select(state => state.AppReducer.tenant.tenantId);

    const currentState = yield select(state => state.IntegrationsReducer);

    const response = yield getIntegrations(
      currentTenantId,
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });
}
